import TabCode from "./TabCode.js";
import { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { modeState } from "../../recoil/index.ts";
import {
  Box,
  Tab,
  Autocomplete,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { getModelDetail } from "../../services/inspModelService.js";
import "../../styles/addStyle.css";
import {
  CustomMuiButton,
  DialogBottomStyle,
  DialogHeaderStyle,
} from "../../utils/styleUtils.js";
import { CloseIcon } from "../../icons/index.tsx";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { t } from "i18next";

export const ModelModal = ({ uuid, setOpenModal, row }) => {
  const [formData, setFormData] = useState([]);
  const mode = useRecoilValue(modeState);
  const [options, setOptions] = useState("{}");
  const [preProcess, setPreProcess] = useState("{}");
  const [postProcess, setPostProcess] = useState("{}");
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();

  useEffect(() => {
    if (row.id) {
      getInspModelInfo();
    }
  }, []);

  const getInspModelInfo = async () => {
    try {
      const response = await getModelDetail(row.id);
      setFormData(response.data);
      setOptions(JSON.stringify(response.data.options));
      setPreProcess(JSON.stringify(response.data.pre_process));
      setPostProcess(JSON.stringify(response.data.post_process));
    } catch (error) {
      console.error(error);
    }
  };

  const handleCodeChange = (type, newValue) => {
    switch (type) {
      case "options":
        setOptions(newValue);
        break;
      case "preProcess":
        setPreProcess(newValue);
        break;
      case "postProcess":
        setPostProcess(newValue);
        break;
      default:
        break;
    }
  };

  const handleEdit = () => {
    navigate(`/insp-model/${row.id}`);
  };

  const handleClose = () => {
    navigate("/home", { state: { tab: "insp_model" } });
    setOpenModal(false);
    setFormData(null);
  };

  return (
    <div style={{ width: "700px" }}>
      <div className="form-container">
        <Box
          sx={{
            ...DialogHeaderStyle,
            p: "8px 0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{
              fontWeight: "700",
              color: "var(--text-color)",
            }}
            fontFamily={"NotoSansKR-Variable"}
          >
            View Model
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <div className="input-container">
          <span className="modal-option-title">Model Name</span>
          <span className="custom-text">{formData.name || "-"}</span>
        </div>
        <div className="input-container">
          <span className="modal-option-title">Description</span>
          <span className="custom-text">{formData.description || "-"}</span>
        </div>
        <TabCode
          firstData={options}
          secondData={preProcess}
          thirdData={postProcess}
          state={mode}
          onCodeChange={handleCodeChange}
        />
        <Box
          sx={{
            ...DialogBottomStyle,
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            // marginTop: 3,
            paddingTop: "5px",
          }}
        >
          <CustomMuiButton
            onClick={handleClose}
            variant="text"
            label={t("Close")}
          />
          <CustomMuiButton
            onClick={handleEdit}
            variant="contained"
            label={t("Edit")}
          />
        </Box>
      </div>
    </div>
  );
};
